import Life from './Life';

export default Life;
